import type { ChangeEvent, ReactNode } from 'react'
import { Checkbox } from '@mote/ui/components'
import { x } from '@xstyled/styled-components'
import { useOnboarding } from '../context'

export type ConsentOnChangeKey = 'consent' | 'newsletter'

export interface ConsentProps {
  label: string | ReactNode
  checked: boolean
  onChange: (key: ConsentOnChangeKey, checked: boolean) => void
}

export const Consent = (props: ConsentProps): JSX.Element => {
  const { state } = useOnboarding()
  const handleOnChange = (key: ConsentOnChangeKey, checked: boolean): void => {
    props.onChange(key, checked)
  }

  return (
    <x.div
      display='flex'
      flexDirection='column'
      px={8}
      py={4}
      gap={4}
      borderRadius='md'
      bg='grey.l4'
    >
      <>
        {/*@ts-expect-error*/}
        <Checkbox
          size='lg'
          label={props.label}
          checked={props.checked}
          align='flex-start'
          onChange={(event: ChangeEvent<HTMLInputElement>) =>
            handleOnChange('consent', event.target.checked)
          }
        />
        {state.survey.is_minor?.value ? null : (
          // @ts-expect-error
          <Checkbox
            size='lg'
            label='Send me occasional updates about Mote features and content'
            align='flex-start'
            onChange={(event: ChangeEvent<HTMLInputElement>) =>
              handleOnChange('newsletter', event.target.checked)
            }
          />
        )}
      </>
    </x.div>
  )
}
